import React from 'react';
import Dropzone from 'react-dropzone';
import config from '../../../../config';

class ImageUploader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      uploadedFile: null,
      errorMessage: null,
    };
  }

  onImageDrop(files) {
    if (!files || !files[0]) {
      return;
    }

    this.setState({
      uploadedFile: files[0],
      errorMessage: null,
    });

    this.handleImageUpload(files[0]);
  }

  onDropRejected(rejectedFiles) {
    if (!rejectedFiles || !rejectedFiles[0]) {
      return;
    }

    const rejection = rejectedFiles[0];
    if (rejection.errors && rejection.errors.some(error => error.code === 'file-too-large')) {
      this.setState({
        errorMessage: 'File size exceeds the maximum limit of 300 KB. Please choose a smaller file.',
      });
    } else {
      this.setState({
        errorMessage: 'File was rejected. Please ensure it is a valid image file and that it is less than 300 KB.',
      });
    }
  }

  async handleImageUpload(file) {
    if (!file || !file.name) {
      console.error('Invalid file provided to handleImageUpload');
      return;
    }

    try {
      // Generate a unique key for the file
      const timestamp = Date.now();
      const fileName = file.name.replace(/[^a-zA-Z0-9.-]/g, '_'); // Sanitize filename
      const key = `uploads/${timestamp}-${fileName}`;

      // Step 1: Request the signed POST URL from our backend
      const token = localStorage.getItem('user_token');
      const response = await fetch(`${config.api_path}/image-upload`, {
        method: 'POST',
        headers: {
          'jwt': token,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ key }),
      });

      if (!response.ok) {
        if (response.status === 401) {
          console.error('Unauthorized - please log in again');
          if (this.props.signOut) {
            this.props.signOut();
          }
          return;
        }
        throw new Error(`Failed to get presigned URL: ${response.statusText}`);
      }

      const { url, fields } = await response.json();

      console.log('Presigned POST response:', { url, fields }); // Debug log

      // Step 2: Upload the image to S3 using the presigned POST URL
      const formData = new FormData();
      
      // Add all the fields from the presigned POST (including 'key', 'policy', 'x-amz-*', etc.)
      // The 'key' field is a string value specifying the S3 object path
      Object.keys(fields).forEach((fieldName) => {
        formData.append(fieldName, fields[fieldName]);
      });
      
      // CRITICAL: Ensure Content-Type field is set - the presigned POST policy requires it to start with "image/"
      // If Content-Type is not in fields, add it using the file's MIME type
      const contentType = file.type || 'image/jpeg';
      if (!fields['Content-Type'] && !fields['content-type']) {
        formData.append('Content-Type', contentType);
      }
      
      // Append the file - the field name for the file in S3 presigned POST is typically 'file'
      // However, ensure the filename matches the key's filename to avoid 403 errors
      const keyFilename = fields.key ? fields.key.split('/').pop() : file.name;
      console.log('Uploading file with key filename:', keyFilename, 'Content-Type:', contentType); // Debug log
      formData.append('file', file, keyFilename);

      const uploadResponse = await fetch(url, {
        method: 'POST',
        body: formData,
      });

      if (!uploadResponse.ok) {
        const errorText = await uploadResponse.text();
        console.error('S3 upload error response:', errorText);
        throw new Error(`Failed to upload image: ${uploadResponse.status} ${uploadResponse.statusText}. ${errorText}`);
      }

      // Construct the final image URL
      // The presigned POST URL is like: https://bucket.s3.region.amazonaws.com/
      // We need to append the key to get the full URL
      const urlObj = new URL(url);
      const imageUrl = `${urlObj.protocol}//${urlObj.host}/${key}`;

      console.log('Image uploaded successfully:', imageUrl);
      this.props.handleNewImage(imageUrl);
    } catch (err) {
      console.error('Error uploading image:', err);
    }
  }

  render() {
    return (
      <form>
        <div className="FileUpload">
          <Dropzone
            onDrop={this.onImageDrop.bind(this)}
            onDropRejected={this.onDropRejected.bind(this)}
            multiple={false}
            accept="image/*"
            maxSize={307200}
          >
            <div>Drop an image or click to select a file to upload.</div>
          </Dropzone>
          {this.state.errorMessage && (
            <div style={{ color: 'red', marginTop: '10px' }}>
              {this.state.errorMessage}
            </div>
          )}
        </div>
        <div>
          {this.state.uploadedFile ? (
          <div>
            <p>{this.state.uploadedFile.name}</p>
            <img src={this.state.uploadedFileCloudinaryUrl} />
          </div>
          ) : null}
        </div>
      </form>
    );
  }
}

export default ImageUploader;
